import permissionsService from "../shared/services/permissionsService";

const REQUEST_PERMISSIONS = "REQUEST_PERMISSIONS";
const RESPONSE_PERMISSIONS = "RESPONSE_PERMISSIONS";
const REQUEST_PERMISSIONS_FAILURE = "REQUEST_PERMISSIONS_FAILURE";

const requestPermissionsAction = () => {
  return {
    type: REQUEST_PERMISSIONS,
  };
};

const responsePermissionsAction = (data) => {
  return {
    type: RESPONSE_PERMISSIONS,
    data,
  };
};

const requestPermissionsFailureAction = (errors) => {
  return {
    type: REQUEST_PERMISSIONS_FAILURE,
    errors,
  };
};

const getPermissions = (options) => {
  return (dispatch) => {
    dispatch(requestPermissionsAction());

    permissionsService
      .getPermissions(options)
      .then((result) => {
        dispatch(responsePermissionsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestPermissionsFailureAction(error.response));
      });
  };
};

export { REQUEST_PERMISSIONS, RESPONSE_PERMISSIONS, REQUEST_PERMISSIONS_FAILURE, getPermissions };
